import { createSlice, PayloadAction, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { AlarmApi } from "./api";
import { AlarmData} from "../Common/Types/types";
import { RootState } from "../Core/Store";
import { Params } from "../Common/Slices/ParamSlice";

const initialAlarmData:AlarmData[] = [];

interface alarmSliceState {
    alarmData:AlarmData[];
    alarmDataWithScope: AlarmData[];
    loadingState?: string;
    errorMessage?: string;
    loadingStateWithScope?: string;
    errorMessageWithScope?: string;

}

const initialState: alarmSliceState = {
    alarmData:initialAlarmData,
    alarmDataWithScope:initialAlarmData,
    loadingState: undefined,
    errorMessage: undefined,
    loadingStateWithScope: undefined,
    errorMessageWithScope: undefined
};

export const fetchAlarmDatas = createAsyncThunk<AlarmData[],Params>(
    "alarms/fetchAlarmDatas",
    async (params:Params) => {
        const response = await AlarmApi.getInterruptingAlarmDatas(params);
        
      return response;
    }
); 

export const fetchAlarmDatasWithScope = createAsyncThunk<AlarmData[],Params>(
  "alarms/fetchAlarmDatasWithScope",
  async (params:Params) => {
    const response = await AlarmApi.getInterruptingAlarmDatasWithScope(params)
    return response;
  }
); 

const alarmSlice = createSlice({
    name: "alarms",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      //
      builder.addCase(fetchAlarmDatas.fulfilled, (state, action) => {
        return {
          ...state,
          loadingState: "fulfilled",
          errorMessage: undefined,
          alarmData: action.payload,
        };
      });
      builder.addCase(fetchAlarmDatas.rejected, (state, action) => {
        return {
          ...state,
          loadingState: "rejected",
          errorMessage: "error",
        };
      });
      builder.addCase(fetchAlarmDatas.pending, (state, action) => {
        return {
          ...state,
          loadingState: "pending",
          errorMessage: undefined,
        };
      });
      //with scope
      builder.addCase(fetchAlarmDatasWithScope.fulfilled, (state, action) => {
        return {
          ...state,
          loadingStateWithScope: "fulfilled",
          errorMessageWithScope: undefined,
          alarmDataWithScope: action.payload,
        };
      });
      builder.addCase(fetchAlarmDatasWithScope.rejected, (state, action) => {
        return {
          ...state,
          loadingStateWithScope: "rejected",
          errorMessageWithScope: "error",
        };
      });
      builder.addCase(fetchAlarmDatasWithScope.pending, (state, action) => {
        return {
          ...state,
          loadingStateWithScope: "pending",
          errorMessageWithScope: undefined,
        };
      });
    },
  });
  
export const getAlarmsSelector = (state: RootState) => state.alarms.alarmData;
export const getAlarmsWithScopeSelector = (state: RootState) => state.alarms.alarmDataWithScope;
export const getAlarmsLoadingSelector = (state: RootState) => state.alarms.loadingState;
export const getAlarmsLoadingSelectorWithScope = (state: RootState) => state.alarms.loadingStateWithScope;

export const loadingAlarmsSelector = (state: RootState) => state.alarms.loadingState;
export default alarmSlice.reducer;